import { render } from "./MathAwareText.vue?vue&type=template&id=5a4c518c&scoped=true&ts=true"
import script from "./MathAwareText.vue?vue&type=script&lang=ts"
export * from "./MathAwareText.vue?vue&type=script&lang=ts"

import "./MathAwareText.vue?vue&type=style&index=0&id=5a4c518c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4c518c"]])

export default __exports__